/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilSquareIcon24Solid = forwardRef('ToolPencilSquareIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M9 12.914V14.5a.5.5 0 0 0 .5.5h1.586a1 1 0 0 0 .707-.293l8.961-8.961-2.5-2.5-8.961 8.961a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m23.293 3.207-1.465 1.465-2.5-2.5L20.793.707a1 1 0 0 1 1.414 0l1.086 1.086a1 1 0 0 1 0 1.414Z" }),
        React.createElement("path", { d: "M6.5 2h10.702L7.85 11.351a1.625 1.625 0 0 0-.476 1.15V15c0 .897.728 1.624 1.625 1.624h2.5c.431 0 .844-.171 1.149-.476L22 6.8V17.5a4.5 4.5 0 0 1-4.5 4.5h-11A4.5 4.5 0 0 1 2 17.5v-11A4.5 4.5 0 0 1 6.5 2Z" })));
});
